(function() {

  // break point
  var replaceWidth = 501;


  function ballon(){
    const ballonSource = `
      <div class="c-ballon" style="display:none;">
        <div class="c-ballon__inner">
          <button class="c-ballon__close"></button>
          <p class="c-ballon__thanks">カートに追加されました！<br><small>※取り消しや枚数変更は<br>ご購入手続き時に変更可能です</small></p>
          <p class="c-link01"><a href="https://www.motherhouse.co.jp/cart">購入手続きに進む</a></p>
        </div>
      </div>
    `;

    const ballonTrigger = $('.js-ballon__button');
    const ballonCloseTrigger = $('.c-ballon__close');

    function ballonOpen(){
      ballonClose();
      const ballonWrap = this.parentElement;
      let selectVal = this.parentElement.previousElementSibling.firstElementChild.value;
      if(selectVal != 0){
        $(ballonWrap).append(ballonSource);
        $(ballonWrap).ready(function(){
          let ballonObj = $('.c-ballon');
          ballonObj.hide().fadeIn(300);
        });
      }
    }

    function ballonClose(){
      let ballonObj = $('.c-ballon');
      if(ballonObj.length > 0){
        ballonObj.hide().fadeOut(300).remove();
      }
    }

    for (let i = 0; i < ballonTrigger.length; i++) {
      ballonTrigger[i].addEventListener("click", ballonOpen);
    }

    $(document).on('click', '.c-ballon__close', function() {
      ballonClose();
    });
    $(document).on('click', '.c-modal__close', function() {
      ballonClose();
    });
  }


  function discovery(){

    document.querySelectorAll('.js-discovery').forEach(function(el){
      const discoveryTrigger = el.querySelector('.js-discovery__trigger');
      const discoveryContent = el.querySelector('.js-discovery__inner');

      discoveryTrigger.addEventListener("click", (event) => {
        if(!discoveryContent.classList.contains('is-discovered')){
          discoveryContent.classList.add("is-discovered");
        }else{
          discoveryContent.classList.remove("is-discovered");
        }
      });
    });
  }

  //Scrollで要素表示した時点でclassを追加
  function scrolledAnim(){
    /* ------------------ スクロールでclass追加 ------------------ */
    if($('.js-addClass').length){
      $('.js-addClass').waypoint(function (direction) {
        var activePoint = $(this.element);
        if (direction === 'down') {
          activePoint.addClass('is-active');
          setTimeout(function(){
            activePoint.siblings('.js-addClass02').addClass('is-active');
          },200);
          setTimeout(function(){
            activePoint.siblings('.js-addClass03').addClass('is-active');
          },600);
          setTimeout(function(){
            activePoint.siblings('.js-addClass04').addClass('is-active');
          },900);
        }
      }, {
        offset: '90%'
      });

    }
  }
  setTimeout(() => {
    scrolledAnim();
  }, 600);

  $('.js-slide01').slick({
    slidesToShow: 1,
    autoplaySpeed: 3000,
    dots: false,
    infinite: true,
    autoplay: true,
    arrows: false,
    centerMode: true,
    centerPadding: '10%',
    swipe: true,
    responsive: [{
      breakpoint: replaceWidth,
        settings: {
          infinite: true,
          slidesToShow: 1,
          arrows: false,
          swipe: true,
      }
    }]
  });

  var notList = ".modaal-btn, .remodal-close";
  $('a[href^="#"]').not(notList).click(function() {
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top;

    $('html, body').animate({
      scrollTop: position
    }, 300, 'swing');
    return false;
  });


  /* --------------------------------------------
  load時
  -------------------------------------------- */
  $(window).on('load', function() {
    ballon();
    discovery();
  });

}());
